<template>
  <div class="wrapper">

    <Background v-if="!loading"/>

    <Nav v-if="!loading" :fixed="false">
      <template v-slot:logo-box>
        <Logo/>
      </template>
      <template v-slot:options-box>
        <DialoguesButton/>
        <Title :title="getTitle"/>
        <EditButton :shortId="getShortId" :ownerId="getOwner" :type="getType"/>
        <PinButton :shortId="getShortId" :ownerId="getOwner" :type="getType" :exerciseId="getExerciseId"/>
      </template>
    </Nav>

    <div class="loading" v-if="loading">
      <Loader color="white"/>
    </div>

    <div class="start-layer" v-if="!loading">
      <div class="button-wrapper">
        <div :class="{'button-box': true, 'inactive': !getActivePlayModes.play}" @click="play">
          <div class="circle-box">
            <div class="circle">
              <font-awesome-icon icon="play" class="play-icon"/>
            </div>
          </div>
          <div class="label">Play</div>
        </div>
        <div :class="{'button-box': true, 'inactive': !getActivePlayModes.learn}" @click="learn">
          <div class="circle-box">
            <div class="circle">
              <font-awesome-icon icon="book-open" class="learn-icon"/>
            </div>
          </div>
          <div class="label">Learn</div>
        </div>
        <div :class="{'button-box': true, 'inactive': !getActivePlayModes.record}" @click="record">
          <div class="circle-box">
            <div class="circle">
              <font-awesome-icon icon="microphone-alt" class="record-icon"/>
            </div>
          </div>
          <div class="label">Record</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import alert from '@/lib/alert'
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex';
import Background from '@/components/Hub/Background'
import Loader from '@/components/Loader'
//Nav
import Nav from '@/components/Nav/Nav'
import Logo from '@/components/Nav/Logo'
import DialoguesButton from '@/components/Nav/DialoguesButton'
import Title from '@/components/Nav/Title'
import EditButton from '@/components/Nav/EditButton'
import PinButton from '@/components/Nav/PinButton'

export default {
  name: 'Hub',
  data() {
    return {
      loading: true,
      ownerLimit: false,
    }
  },
  components: {
    Background,
    Loader,
    //Nav
    Nav,
    Logo,
    DialoguesButton,
    Title,
    EditButton,
    PinButton
  },
  methods: {
    ...mapActions('hub', ['clear', 'loadData']),
    ...mapActions('player', ['playerStop']),
    exit() {
      this.playerStop();
      this.$router.push('/');
    },
    play() {
      if(this.getActivePlayModes.play) {
        this.$router.push(`/play?exercise_id=${this.getExerciseId}`);
      }
    },
    learn() {
      if(this.getActivePlayModes.learn) {
        this.$router.push(`/learn?exercise_id=${this.getExerciseId}`);
      }
    },
    record() {
      if(this.getActivePlayModes.record) {
        this.$router.push(`/record?exercise_id=${this.getExerciseId}`);
      }
    }
  },
  created() {
    this.playerStop();
    this.clear();
    const urlParams = new URLSearchParams(window.location.search);
    const exerciseId = urlParams.get('exercise_id');
    
    this.loadData(exerciseId).then(() => {
      this.loading = false;
    }).catch(err => {
      alert.showError(err);
      this.$router.push('/');
    })
  },
  computed: {
    ...mapGetters('hub', ['getTitle', 'getExerciseId', 'getActivePlayModes', 'getShortId', 'getOwner', 'getType']),
  },
  beforeRouteEnter(to, from, next) {
    const exerciseId = to.query.exercise_id;
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_SERVER_URL}limitSolving`,
      data: {
        exerciseId
      }
    }).then(() => {
      next();
    }).catch(() => {
      console.log('Limit Error');
      alert.showError('Dialog limit reached');
      next(vm => {
        vm.ownerLimit = true;
      });
    })
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(62, 64, 70);
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;
}

.start-layer {
  flex: auto;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  z-index: 3;

  .button-wrapper {
    width: auto;
    height: 12rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-top: -3rem;
    @media (max-width: 600px) {
      width: 90%;
      height: auto;
      flex-direction: column;
      justify-content: space-evenly;
      margin-top: 0rem;
    }
  }

  .button-box {
    width: 10rem;
    height: 12rem;
    display: flex;
    margin-left: 2rem;
    margin-right: 2rem;
    flex-direction: column;
    background-color: rgb(62, 64, 70);
    filter:drop-shadow(8px 8px 20px rgba(0, 0, 0, 0.349));
    border-radius: 0.3rem;
    user-select: none;
    transition: 0.3s;
    animation: slide-up 0.5s forwards;
    @media (max-width: 600px) {
      width: 100%;
      height: 7rem;
      margin-left: 2rem;
      margin-right: 2rem;
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
      flex-direction: row;
    }
    @keyframes slide-up {
      0% {
        transform: translateY(5rem);
      }
      100% {
        transform: translateY(0rem);
      }
    }

    &:hover {
      cursor: pointer;
      transform: scale(1.05);
      filter:drop-shadow(8px 8px 20px rgba(53, 53, 53, 0.671));

      .circle {
        background-color: #ebc659;
        color: white;
      }
      .label {
        color: #ebc659;
      }
    }
  }

  .inactive {
    filter: blur(2px) opacity(80%);
    display: none;
    &:hover {
      cursor: unset;
      transform: none;
      filter: blur(2px) opacity(80%);

      .circle {
        background-color: rgba(255, 255, 255, 0.719);
        color: rgb(62, 64, 70);
      }
      .label {
        color: rgba(255, 255, 255, 0.719);
      }
    }
  }

  .circle-box {
    width: 100%;
    height: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 600px) {
      height: 100%;
      width: auto;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
  }

  .circle {
    width: 6rem;
    height: 6rem;
    background-color: rgba(255, 255, 255, 0.719);
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(62, 64, 70);
    font-size: 2.3rem;
    transition: 0.3s;
    @media (max-width: 600px) {
      width: 5rem;
      height: 5rem;
      font-size: 1.9rem;
    }
  }

  .play-icon {
    margin-left: 0.3rem;
  }

  .label {
    width: 100%;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    color: rgba(255, 255, 255, 0.719);
    font-size: 1.1rem;
    transition: 0.3s;
    @media (max-width: 600px) {
      height: 100%;
      flex: 1;
      align-items: center;
      justify-content: flex-start;
      font-size: 1.4rem;
    }
  }
}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
}
</style>